import * as yup from 'yup'

export const FixedRouteSchema = yup.object().shape({
  name: yup.string().required('Please enter a route name.'),
  pickup: yup.object().shape({
    addressLine1: yup
      .string()
      .required('Please select a valid pickup location'),
  }),
  dropOff: yup.object().shape({
    addressLine1: yup
      .string()
      .required('Please select a valid dropoff location'),
  }),
})
